import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"cross\"><path fill-rule=\"evenodd\" d=\"M8 .457 7.543 0 4 3.543.457 0 0 .457 3.543 4 0 7.543.457 8 4 4.457 7.543 8 8 7.543 4.457 4z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol